// https://github.com/moment/moment/blob/000ac1800e620f770f4eb31b5ae908f6167b0ab2/src/lib/duration/create.js#L17
const isoDurationRegex =
    /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

export interface ParsedIsoDurationType {
    years: number;
    months: number;
    weeks: number;
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
}

const parseIsoDuration = (isoDuration: string): ParsedIsoDurationType => {
    /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion  -- (https://aka.ms/OWALintWiki)
     * Non-null assertions are dangerous, as they can hide bugs from strictness checks. Please remove this usage or replace this line with a justification.
     *	> Forbidden non-null assertion. */
    const matches = isoDuration.match(isoDurationRegex)!;
    return {
        years: matches[2] === undefined ? 0 : +matches[2],
        months: matches[3] === undefined ? 0 : +matches[3],
        weeks: matches[4] === undefined ? 0 : +matches[4],
        days: matches[5] === undefined ? 0 : +matches[5],
        hours: matches[6] === undefined ? 0 : +matches[6],
        minutes: matches[7] === undefined ? 0 : +matches[7],
        seconds: matches[8] === undefined ? 0 : +matches[8],
    };
};

export default parseIsoDuration;
